import { useQuery } from '@tanstack/react-query';
import api from '@app/services/api';
import { apiEndpoints } from '@app/utils/constants';
import type { UseQueryOptions } from '@tanstack/react-query';
import type { ApiError, AIAgentListParams, AIAgentListResponse } from '@app/services/api.types';

type QueryOptions = Omit<UseQueryOptions<AIAgentListResponse, ApiError>, 'queryKey' | 'queryFn'>;

export const fetchAgentList = async (params: AIAgentListParams): Promise<AIAgentListResponse> => {
	const url = apiEndpoints.aiAgents.getList(params);
	const response = await api.get(url);
	return response?.data?.data;
};

const useAgents = (params: AIAgentListParams, options?: QueryOptions) => {
	return useQuery<AIAgentListResponse, ApiError>({
		queryKey: ['ai-agent', 'list', params],
		queryFn: () => fetchAgentList(params),
		...options,
	});
};

export default useAgents;
